import { useLang } from '@/i18n';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useProductDispatch, useProductStore } from '../ProductProvider';
import NavProduct from '../tabs/NavProduct';
import TabBundles from '../tabs/TabBundles';
import TabMedia from '../tabs/TabMedia';
import TabSpecs from '../tabs/TabSpecs';
import TabSupport from '../tabs/TabSupport';
import styles from './index.module.scss';
import ProductContent from './ProductContent';

const theme = 'white';
const tabList = ['Product', 'Support', 'Specs', 'Media'];
export default function Detail() {
    const { productTabActive } = useProductStore();
    const dispatch = useProductDispatch();
    const router = useRouter();
    const { locale = '', query } = router;
    const tabName: string = (query.tab as string) || '';
    const { t } = useLang('theProduct.ListC');

    const items: any[] = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1723030469186/a1.png',
            tag: t('a_label'),
            title: t('a_title'),
            desc: t('a_desc'),
            productId: '7213436534857',
            variantId: '44505650528417',
            quantity: 1,
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724639717832/listC_2.png',
            tag: t('b_label'),
            title: t('b_title'),
            desc: t('b_desc'),
            // desc: `${t('P_card2_power')}\n${t('P_card2_desc')}`,
            productId: '7213436534857',
            variantId: '44505652854945',
            quantity: 1,
        },
        // {
        //     img: 'https://websiteoss.ecoflow.com/upload/image/1723030469537/a3.png',
        //     tag: t('c_label'),
        //     title: t('c_title'),
        //     desc: t('c_desc'),
        //     //productId: '7213436534857',
        //     //variantId: '41435086618697',
        //     quantity: 1,
        //     btnCartText: '11月中旬発売',
        // },
    ];

    const river3plus = {
        img: 'https://websiteoss.ecoflow.com/upload/image/1723030469537/a3.png',
        label: t('c_label'),
        title: t('c_title'),
        desc: t('c_desc'),
        quantity: 1,
        btnCartText: '11月中旬発売',
        inventory: 0,
    };

    const [cards, setCards] = useState(JSON.parse(JSON.stringify(items)));

    const getAsynItem = async (item: any) => {
        const { variantId, productId } = item;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    if (res?.data?.handle) {
                        item.link_more = `https://${locale}.ecoflow.com/products/${res?.data?.handle}?variant=${variantId}`;
                    }
                    item.link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                    return resolve({ ...item, ...res?.data });
                } else {
                    console.error(res?.message);
                    return reject({ ...item });
                }
            } catch (e) {
                console.error(e);
                return reject({ ...item });
            }
        });
    };

    useEffect(() => {
        if (locale === 'jp') {
            const tempArr = JSON.parse(JSON.stringify(items));
            const promises = tempArr?.map((item: any) => getAsynItem(item));
            Promise.all(promises)
                .then((res: any) => {
                    setCards(res);
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }, []);

    useEffect(() => {
        if (tabName && tabList.includes(tabName)) {
            dispatch({
                type: 'changeProductTabActive',
                payload: tabName,
            });
        }
    }, [tabName]);

    return (
        <div className={styles.detail}>
            <NavProduct />
            <div className={`product-item-tab${productTabActive === 'Product' ? ' product-item-tab-active' : ''}`}>
                <ProductContent bundles={[...cards, river3plus]} />
            </div>
            {productTabActive === 'Bundles' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabBundles />
                </div>
            )}
            {productTabActive === 'Support' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSupport theme={theme} />
                </div>
            )}
            {productTabActive === 'Specs' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSpecs theme={theme} />
                </div>
            )}
            <div className={`product-item-tab${productTabActive === 'Media' ? ' product-item-tab-active' : ''}`}>
                <TabMedia />
            </div>
        </div>
    );
}
